export const PROFILE_PAGE = 'profile-page';
export const CREATE_RESUME_PAGE = 'create-resume-page';

export const PAGES = [PROFILE_PAGE, CREATE_RESUME_PAGE] as const;

export const PROFILE_PAGE_URL = '/:lang?/profile/me/:card?/:id?';
export const PROFILE_PAGE_URL_REGEX =
  /^\/([^/]+)?\/profile\/me(?:\/[^/]+)?(?:\/[^/]+)?$/;
export const CREATE_RESUME_PAGE_URL =
  '/:lang?/profile/me/create-resume/:card?/:id?';
export const CREATE_RESUME_PAGE_URL_REGEX =
  /^\/(?:[^/]+\/)?profile\/me\/create-resume(?:\/[^/]+)?(?:\/[^/]+)?$/;

export const PAGE_URLS = {
  [PROFILE_PAGE]: PROFILE_PAGE_URL,
  [CREATE_RESUME_PAGE]: CREATE_RESUME_PAGE_URL,
};

export const APPROACHABILITY = 'approachability';
export const AVAILABILITY = 'availability';
export const CAREER_HISTORY = 'career-history';
export const CLASSIFICATION = 'classification';
export const CREATE_RESUME = 'create-resume';
export const EDUCATION = 'education';
export const FINISH_RESUME = 'finish-resume';
export const LANGUAGES = 'languages';
export const LICENCES = 'licences';
export const NEXT_ROLE = 'next-role';
export const PERSONAL_DETAILS = 'personal-details';
export const PREFERRED_LOCATIONS = 'preferred-locations';
export const PROFILE_INSIGHTS = 'profile-insights';
export const PROFILE_VISIBILITY = 'profile-visibility';
export const PROFILE_VISIBILITY_V2 = 'profile-visibility-v2';
export const REFERENCES = 'references';
export const REPORT_PROFILE = 'report-profile';
export const RESUME = 'resume';
export const RIGHT_TO_WORK = 'right-to-work';
export const SALARY = 'salary';
export const SKILLS = 'skills';
export const START_RESUME = 'start-resume';
export const SUGGESTIONS = 'suggestions';
export const SUMMARY = 'summary';
export const TIPS = 'tips';
export const VERIFICATIONS = 'verifications';
export const VERIFIED_IDENTITY = 'identity';
export const WORKTYPES = 'work-types';
export const PEOPLE_SEARCH = 'people-search';

export const CARDS = [
  APPROACHABILITY,
  AVAILABILITY,
  CAREER_HISTORY,
  CLASSIFICATION,
  CREATE_RESUME,
  EDUCATION,
  FINISH_RESUME,
  LANGUAGES,
  LICENCES,
  NEXT_ROLE,
  PERSONAL_DETAILS,
  PREFERRED_LOCATIONS,
  PROFILE_INSIGHTS,
  PROFILE_VISIBILITY,
  PROFILE_VISIBILITY_V2,
  REFERENCES,
  REPORT_PROFILE,
  RESUME,
  RIGHT_TO_WORK,
  SALARY,
  SKILLS,
  START_RESUME,
  SUGGESTIONS,
  SUMMARY,
  TIPS,
  VERIFICATIONS,
  VERIFIED_IDENTITY,
  WORKTYPES,
  PEOPLE_SEARCH,
] as const;

export const SLUGS = [
  CAREER_HISTORY,
  EDUCATION,
  LANGUAGES,
  LICENCES,
  NEXT_ROLE,
  PERSONAL_DETAILS,
  REFERENCES,
  RESUME,
  SKILLS,
  SUGGESTIONS,
  SUMMARY,
  TIPS,
];

export const DRAWER_CARDS = [
  APPROACHABILITY,
  AVAILABILITY,
  CAREER_HISTORY,
  CLASSIFICATION,
  EDUCATION,
  LANGUAGES,
  LICENCES,
  PERSONAL_DETAILS,
  PREFERRED_LOCATIONS,
  PROFILE_INSIGHTS,
  REFERENCES,
  REPORT_PROFILE,
  RESUME,
  RIGHT_TO_WORK,
  SALARY,
  SKILLS,
  SUMMARY,
  VERIFICATIONS,
  WORKTYPES,
] as const;
